<template>
  <div class="profile">
    <div class="profile__button">
        <i class="fas fa-user profile__button__user-icon" :style="{ fontSize: '1.25em' }"></i>
        <p class="profile__button__name"> {{user.name}} </p>
        <i class="fas fa-chevron-circle-down profile__button__chevron" :style="{ fontSize: '1.25em' }"></i>
    </div>

    <div class="profile__dropdown">
      <router-link to="/assets" class="link link--grey"> Mina tillgångar </router-link>
      <router-link to="/settings" class="link link--grey"> Min profil </router-link>
      <router-link
        v-if="checkIfAdmin()"
        to="/admin-page"
        class="link link--grey"
      >
        Admin sidan
      </router-link>
      <router-link class="link link--grey" to="" @click.native="signOut"> Logga ut </router-link>
    </div>
  </div>
</template>

<script>
import { eraseCookie } from '../../services/cookie';

export default {
  name: 'Profile',
  props: [ 'user' ],
  methods: {
    signOut() {
      eraseCookie('pod');
      location.reload();
    },
    checkIfAdmin () {
      return this.user.role === 'admin'
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  position: relative;
  margin: 0 1rem;

  &__button {
    display: none; // Or display flex
    align-items: center;
    border-radius: 1.52em;
    cursor: pointer;
    text-transform: uppercase;
    font-family: "Roboto", sans-serif;
    font-weight: bold;
    transition: all .5s ease-in-out;
    padding: 13px;
    color: $white;
    background-color: $mediumGreen;

    &:hover {
      background-color: $lightGreen;
      cursor: pointer;
    }

    &__name {
      display: none;
    }

    &__chevron {
      display: none;
    }

    @include breakpoints(xLarge) {
      display: flex;

      &__name {
        display: block;
        font-size: 1.25rem;
        color: $white;
        margin: 0 2rem;
      }

      &__chevron {
        display: block;
      }
    }
  }

  &__dropdown {
    position: absolute;
    height: 0;
    width: 200px;
    overflow: hidden;
    transition: all .5s ease-in-out;
    z-index: 6;
    right: 0;

    @include breakpoints(xLarge) {
      width: 100%;
    }

    a {
      color: rgba($color:$gray, $alpha: 0.9);
      display: flex;
      font-size: 1rem;
      transition: color .15s ease-out,letter-spacing .15s ease-in;
      padding: 1.17em .58em;
      letter-spacing: .008em;
      box-shadow: 0px .3em .5em 0px rgba(0,0,0,0.2);

      &:nth-child(odd) {
        background-color: darken($color: $light, $amount: 2);;
      }

      &:nth-child(even) {
        background-color: darken($color: $light, $amount: 8);
      }

      &:hover {
        color: darken(rgba($color:$gray, $alpha: 1), $amount: 10);
        letter-spacing: normal;
      }

      &:nth-child(1){
        border-radius: .19rem .19rem 0px 0px;
      }

      &:last-child{
        border-radius: 0px 0px .19rem .19rem;
      }
    }
  }

  &:hover {
    .profile__dropdown {
      height: 300px;
      display: block;
      z-index: 200; // Place over popup
    }

    .profile__button {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

</style>
